// extracted by mini-css-extract-plugin
module.exports = {"title":"pointsReceivedBackCard_title__31lV4","subTitle":"pointsReceivedBackCard_subTitle__gc_Bh"};